<script setup>
import {ref} from 'vue'
import Text from "./Forms/Text.vue";
import AddNewFields from "./Forms/AddNewFields.vue";

const props = defineProps({
  sepa: Boolean,
  commercial: Boolean,
  iban: String,

  bank_account_name_differs: String,
  bank_account_name: String,
  bank_account_name_error: String,

  large: Boolean,
  compressed: Boolean,
})

const sepa = ref(props.sepa);
const commercial = ref(props.commercial);
const iban = ref(props.iban);

const bankAccountNameError = ref(props.bank_account_name_error)
const bankAccountNameDiffers = ref(props.bank_account_name_differs)

</script>
<style>

</style>
<template>
  <div class="col-6 col-md-3">
    <input
        type="radio"
        class="btn-check"
        name="options-base"
        id="option5"
        :value="true"
        autocomplete="off"
        v-model="sepa"
    >
    <label
        class="btn btn-vs-radio"
        for="option5"
    >
      SEPA-Lastschrift
    </label>
  </div>
  <div class="col-6 col-md-3">
    <input
        type="radio"
        class="btn-check"
        name="options-base"
        id="option6"
        :value="false"
        autocomplete="off"
        v-model="sepa"
    >
    <label
        class="btn btn-vs-radio"
        for="option6"
    >
      Überweisung
    </label>
  </div>

  <div
      class="row col-12"
      v-if="sepa === true"
  >
    <div class="col-12 pt-4">
      <label for="iban">
        IBAN *
      </label>

      <input
          type="text"
          id="iban"
          name="iban"
          class="form-control form-control-lg"
          :value="iban"
          required
      >
    </div>
    <input
        type="hidden"
        name="sepa_accepted"
        value=1
    >

    <div class="col-md-12 pt-4">
      <AddNewFields
          field="bank_account_name_differs"
          label="Der Kontoinhaber unterscheidet sich vom Auftraggeber"
          v-model:addNewFields="bankAccountNameDiffers"
      />
    </div>
    <div
        class="row ms-0 me-0 ps-0 pe-0 pt-4"
        v-if="bankAccountNameDiffers"
    >
      <div
          :class="{ 'col-md-4' : compressed,  'col-md-12' : !compressed}"
          v-if="bankAccountNameDiffers"
      >
        <Text
            field="bank_account_name"
            label="Kontoinhaber"
            :value="bank_account_name"
            :has-error=bankAccountNameError
            :large="large"
        />
      </div>
    </div>

    <p
        class="pt-4"
        v-if="commercial === false"
    >
      <strong>SEPA-Lastschriftmandat akzeptieren:</strong>
      Ich ermächtige die Voltaik Check Inh. Enno Jürgens e.K. Zahlungen von meinem Konto mittels Lastschrift
      einzuziehen.
      Zugleich weise ich hiermit mein Kreditinstitut an, die von der Voltaik Check Inh. Enno Jürgens e.K.
      auf mein Konto gezogenen Lastschriften einzulösen.
    </p>
    <p
        class="pt-4"
        v-if="commercial === true"
    >
      <strong>SEPA-Firmenlastschriftmandat akzeptieren:</strong>
      Ich bestätige, dass ich mit der Zahlungsabwicklung per SEPA-Firmenlastschriftverfahren einverstanden bin.
      Mir ist bekannt, dass es sich dabei um ein Firmenlastschriftmandat (Business-to-Business) handelt, welches nach
      Abschluss des Stromliefervertrags separat zur Unterschrift bereitgestellt wird.
      <br>
      <br>
      Das Mandat wird mir im Anschluss an den Vertragsabschluss übermittelt und ist Voraussetzung für die monatliche
      Zahlungsabwicklung über das angegebene Geschäftskonto. Zugleich weise ich hiermit mein Kreditinstitut an, die von
      der Voltaik Check Inh. Enno Jürgens e.K. auf mein Konto gezogenen Lastschriften einzulösen.
    </p>
  </div>
  <div
      class="row col-12"
      v-if="sepa === false"
  >
    <p class="pt-4">
      Du überweist deine Abschläge selber.
    </p>
    <p>
      Die notwendigen Informationen erhältst du per E-Mail.
    </p>
    <input
        type="hidden"
        name="sepa_accepted"
        value=0
    >
    <input
        type="hidden"
        name="iban"
        :value=null
    >
  </div>
</template>